import GeoJSON from "ol/format/GeoJSON";
import { Polygon } from "ol/geom";
import { vector } from "../views/OLMap/Source";

export const getFeaturesSourceFromJson = (featureName, geojsons) => {
  const FeatureJson = geojsons.filter((a) => a.name === featureName)[0].json;
  return vector({ features: new GeoJSON().readFeatures(FeatureJson) });
};
export const setVisibleOrNot = (map, id, check) => {
  if (map !== null) {
    map
      .getLayers()
      .getArray()
      .filter((t) => t.getClassName() === id)[0]
      .setVisible(check);
  }
};

export const setOpacity = (map, id, value) => {
  if (map !== null) {
    map
      .getLayers()
      .getArray()
      .filter((t) => t.getClassName() === id)[0]
      .setOpacity(value);
  }
};
export const bboxToGeom = (bbox) => {
  const bboxnum = bbox.map((b) => parseFloat(b));
  const coordinates = [
    [
      [bboxnum[0], bboxnum[1]],
      [bboxnum[2], bboxnum[1]],
      [bboxnum[2], bboxnum[3]],
      [bboxnum[0], bboxnum[3]],
      [bboxnum[0], bboxnum[1]],
    ],
  ];

  return new Polygon(coordinates);
};
